import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import { selectedButtonState, selectedMenuState } from "../recoil/index.ts";

export default function ServerPage() {
  const { t } = useTranslation();
  const setSelectedMenu = useSetRecoilState(selectedMenuState);
  const setSelectedButton = useSetRecoilState(selectedButtonState);

  useEffect(() => {
    setSelectedMenu(t("ServerStatus"));
    setSelectedButton(t("ServerStatus"));
  }, []);

  // return <ServerTable />;
}
